// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organization-details-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.organization-details-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.organization-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.organization-detail-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem 1rem 0.95rem;
  border-radius: 0.85rem;
  background: rgba(0, 0, 0, 0.02);
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.organization-detail-card-full {
  grid-column: 1 / -1;
}

.organization-detail-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.organization-detail-value {
  color: var(--secondary-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.organization-path {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.organization-path-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.organization-path-separator {
  color: var(--gray);
  font-weight: 700;
}

.organization-suborganizations {
  min-height: 2.5rem;
}

@media screen and (max-width: 991px) {
  .organization-details-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrganizationDetails/OrganizationDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".organization-details-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.organization-details-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.organization-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.organization-detail-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem 1rem 0.95rem;\n  border-radius: 0.85rem;\n  background: rgba(0, 0, 0, 0.02);\n  border: 0.0625rem solid rgba(0, 0, 0, 0.06);\n}\n\n.organization-detail-card-full {\n  grid-column: 1 / -1;\n}\n\n.organization-detail-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--secondary-color);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.organization-detail-value {\n  color: var(--secondary-color);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.organization-path {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.organization-path-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.organization-path-separator {\n  color: var(--gray);\n  font-weight: 700;\n}\n\n.organization-suborganizations {\n  min-height: 2.5rem;\n}\n\n@media screen and (max-width: 991px) {\n  .organization-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
